import { useEffect, useState } from "react";
import Button from "../components/Button";
import { useTranslation } from 'react-i18next';
import { login } from "../api/api";
import TokenService from "../services/tokenService";
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuth } from "../context/AuthContext";
// import { useAuth } from "../context/AuthContext";
// import { getSubdomain } from "../lib/utils";


const Signin = () => {

  const { t, i18n } = useTranslation();
  const { login: authLogin } = useAuth();
  const history = useHistory();
  const [credentials, setCredentials] = useState({
    username: "",
    password: ""
  });
  const [errorMsg, setErrorMsg] = useState("");

  // const { isAuthenticated } = useAuth();

  // useEffect(()=>{

  //   const emailAddress = credentials.username || "";
  //   const [, domain] = emailAddress.split('@');
  //   const organization = domain.split('.')[0] ?? "";

  //   const subdomain = getSubdomain();

  //   if(!isAuthenticated && subdomain!==organization) {
  //     window.location.href = `http://${organization.toLowerCase()}.localhost:5173/`;
  //   }
  // }, [credentials.username, isAuthenticated])

  useEffect(() => {
    const token = TokenService.getAuthToken();
    if (token) {
      history.push('/home');
    }
  }, [history]);
  
  // useEffect(() => {
  //   if (credentials && credentials.username) {
  //     const emailAddress = credentials.username;
  //     const [, domain] = emailAddress.split('@');
  //     const organization = domain ? domain.split('.')[0] : '';
  
  //     const subdomain = getSubdomain();
  
  //     if (!isAuthenticated && subdomain !== organization) {
  //       window.location.href = `http://${organization.toLowerCase()}.localhost:5173/`;
  //     }
  //   }
  // }, [credentials, isAuthenticated]);
  
  const handleChange = (e) => {
    const { id, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    
    try {
      const user = await login(credentials.username, credentials.password);
  
      if (user) {
        // Use the context login function
        authLogin(TokenService.getAuthToken(), user);
        
        if(user.passwordChangeRequired === true) {
          history.push("/changePassword", {
            firstTimeLogin: true,
            loginToken: TokenService.getAuthToken()
          });
        } else {
          history.push("/home");
        }
      } else {
        setErrorMsg('signin.error');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMsg('signin.error');
    }
  };
  
  return (
    <section className="h-full w-full flex flex-col gap-5 justify-center items-center">
        <form className="border-2 p-10 rounded-xl flex flex-col gap-2 max-w-2/4 justify-center items-start">
            <div className="w-full flex flex-col justify-center items-center mb-5 gap-4">
              <img className="h-24 w-auto" src={`/${window.DEFAULT_THEME}.png`} alt="Logo" />
              <h2 className="text-xl text-center text-cyan-600">{t('signin.SignInToBrokerPortal')}</h2>
            </div>
            <div className="w-full flex justify-center items-center">
              {/* <label htmlFor="username" className="pr-2">{t('signin.Username')}</label> */}
              <input 
                autoComplete="off" 
                id="username" 
                type='text' 
                placeholder={t('signin.Username')} 
                value={credentials.username}
                className="min-w-full"
                onChange={handleChange}
              />
            </div>
            <div className="w-full flex justify-center items-center">
              {/* <label htmlFor="password" className="pr-2">{t('signin.Password')}</label> */}
              <input 
                autoComplete="off" 
                id="password" 
                type='password' 
                placeholder={t('signin.Password')} 
                value={credentials.password}
                className="min-w-full"
                onChange={handleChange}
              />
            </div>
            <div className="w-full flex justify-end items-center my-2">
              <a href="/resetpassword">
                  <p className="text-sm text-cyan-600">{t('signin.forgotPassword')}</p>
              </a>
            </div>
            <div className="w-full flex justify-center items-center">
              <Button variant={"block"} onClick={handleLogin} label={t('signin.signinBtn')} />
            </div>
            <div className="w-full flex flex-col justify-end items-end gap-2 my-2">
              <div className="flex text-sm text-cyan-600 gap-1">
                <a target="_blank" href={i18n.language === 'en' ? window.PRIVACY_LINK_EN : window.PRIVACY_LINK_FR} rel="noreferrer">
                  <p>{t('resetPassword.privacyPolicy')}</p>
                </a>
                <span>&</span>
                <a target="_blank" href={i18n.language === 'en' ? window.TERMS_LINK_EN : window.TERMS_LINK_FR} rel="noreferrer">
                  <p>{t('resetPassword.terms')}</p>
                </a>
              </div>
              <a target="_blank" href={i18n.language === 'en' ? window.RATE_LINK_EN : window.RATE_LINK_FR} rel="noreferrer">
                  <p className="text-sm text-cyan-600">{t('resetPassword.rateSheet')}</p>
              </a>
            </div>
            { errorMsg !== "" && 
              <span className="w-full text-center text-red-500">
                {errorMsg.startsWith('signin.') ? t(errorMsg) : errorMsg}
              </span>
            }
        </form>
        <div className="w-full flex justify-center items-center">
          <p className="text-sm font-semibold">
            {t('signup.dontHaveAccount')} 
            <Link 
              to={`/signup?lang=${i18n.language}`} 
              className="text-blue-600 ml-1 hover:underline"
            >
              {t('signup.signup')}
            </Link>
          </p>
        </div>
    </section>
  );
}

export default Signin;